import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

declare const initComposerEmbedManager: any;

@Component({
  selector: 'app-listing-page',
  templateUrl: './listing.component.html',
  styleUrls: ['./listing.component.scss']
})
export class ListingComponent implements OnInit {
  animate404: boolean = false;
  message: string;

  constructor(
    private route: ActivatedRoute
  ) {

  }

  ngOnInit() {
    //this.message = "test error message";
    this.EmbedDashboard("6296e641e574e21796bae9fb");
  }

  EmbedDashboard(dashboardid: string) {
    const getEmbedManagerPromise =
      initComposerEmbedManager({
        initialToken: '0ac99ac8-307c-4640-b372-5cff1af21e11' // tokenValue is provided by the Trusted Access API
      });

    getEmbedManagerPromise.then((embedManager: any) => {
      embedManager.createComponent('dashboard',
        {
          dashboardId: dashboardid, // dashboard id
          //<property>,... // set of properties
        }
      ).then((dashboard: any) => dashboard.render(
        document.getElementById("embedDash"), // htmlElement
        { width: '100%', height: '100%' }
      ))
    });

  }

}
